import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardBaseCommand } from "./AtgardBaseCommand";
export class RemoveAtgardCommand extends AtgardBaseCommand {

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "RemoveAtgardCommand";

    constructor(atgardGuid: string, kontraktGuid: string) {
        super(RemoveAtgardCommand.$type, CommandType.Delete);
        this.atgardGuid = atgardGuid;
        this.kontraktGuid = kontraktGuid;
    }
}
